import { render, staticRenderFns } from "./ReferrerRelationships.vue?vue&type=template&id=bea5b396&scoped=true"
import script from "./ReferrerRelationships.vue?vue&type=script&lang=js"
export * from "./ReferrerRelationships.vue?vue&type=script&lang=js"
import style0 from "./ReferrerRelationships.vue?vue&type=style&index=0&id=bea5b396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea5b396",
  null
  
)

export default component.exports